import { useEffect, useState } from 'react';
import { useRecoilState } from 'recoil';
import useNav from '../../application/hooks/useNav';
import { useBaseParam } from '../../application/hooks/useBaseParam';
import { HOME_TABS } from '../../application/staticData/home/HOME_TABS';
import * as Atom from '../../application/recoil';
import { getCustPreProductList } from '../../infra/api/getCustPreProductList';
import { SegmentButtons } from 'oui';
import { DefaultBox } from '../etc/LBox/LBox';
import CreditLanding from './CreditLanding';
import MtgLanding from './Mtg/MtgLanding';

const Home = () => {
  const { navigate } = useNav();
  const [personal] = useRecoilState(Atom.personalInfo);
  const [landingInfo, setLandingInfo] = useRecoilState(Atom.loanList);
  const [homeTab, setHomeTab] = useRecoilState(Atom.homeTab);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const fetchCustLoanList = useBaseParam(getCustPreProductList, {
    custSeq: personal.custSeq,
  });

  const navigateMainPage = async () => {
    if (personal.custSeq) {
      const res = await fetchCustLoanList();
      const list = res?.data?.result;
      setLandingInfo(list);
    }

    // if (list?.dayAgo === 0 && list?.preRequestInfoChk === true) {
    //   navigate('/main/result-entry', { replace: true });
    //   setIsLoading(false);
    // } else {
    //   navigate('/main', { replace: true });
    //   setIsLoading(false);
    // }
    navigate('/main', { replace: true });
    setIsLoading(false);
  };

  // todo 이상하다..
  useEffect(() => {
    if (personal.custSeq !== '') {
      navigateMainPage();
    }
  }, [personal.custSeq]);

  if (isLoading) return null;

  const homeElementMap: Record<typeof homeTab, JSX.Element> = {
    'main.landing': <CreditLanding />,
    'main.mtg': <MtgLanding />,
  };

  return (
    <>
      <DefaultBox verticalGap={8}>
        <SegmentButtons
          items={HOME_TABS}
          activeIdx={HOME_TABS.findIndex((item) => item.value === homeTab)}
          varient="b"
          onClickButton={(_, { index }) => setHomeTab(HOME_TABS[index].value)}
        />
      </DefaultBox>
      {homeElementMap[homeTab]}
    </>
  );
};

export default Home;
